import React from 'react';
import { withTheme } from 'styled-components';
import { localize } from 'core/localization';
import { Figure } from './Figure.styled';

type SadResultProps = {
  theme: { [key: string]: any };
};
export const SadResult = (props: SadResultProps) => (
  <Figure
    width="260px"
    height="142px"
    viewBox="0 0 260 142"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    arialabel={`${localize('[aria label failed course]')}`}
  >
    <title>C6B9A5D1-B3CB-45AF-9203-7F1332548A93</title>
    <defs>
      <filter
        x="0.0%"
        y="0.0%"
        width="100.0%"
        height="100.0%"
        filterUnits="objectBoundingBox"
        id="filter-1"
      >
        <feGaussianBlur stdDeviation="0" in="SourceGraphic" />
      </filter>
      <filter
        x="0.0%"
        y="0.0%"
        width="100.0%"
        height="100.0%"
        filterUnits="objectBoundingBox"
        id="filter-2"
      >
        <feGaussianBlur stdDeviation="0" in="SourceGraphic" />
      </filter>
      <circle id="path-3" cx="185" cy="95" r="16" />
    </defs>
    <g
      id="Combo3(msSection,SubmitAll,Lim,NoContent)"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Combo3-09-Failed-All-atempts-has-been-used"
        transform="translate(-780.000000, -120.000000)"
      >
        <g id="Group" transform="translate(780.000000, 120.000000)">
          <ellipse
            id="Oval-6"
            fill="#363E4E"
            opacity="0.100000001"
            filter="url(#filter-1)"
            cx="130"
            cy="138.5"
            rx="49"
            ry="3.5"
          />
          <path
            d="M74.4791667,35.6669996 L20.9852982,35.6669996 C20.9852982,35.6669996 11.6071429,36.6785686 11.6071429,44.1332573 C11.6071429,51.5879459
            20.9852982,52.5995149 20.9852982,52.5995149 L52.8125,52.6599882 C52.8125,52.6599882 60.2604167,54.1113467 60.2604167,60.6424597
            C60.2604167,67.1735728 52.8125,69.1087174 52.8125,69.1087174 L36.3690476,69.1087174 C36.3690476,69.1087174 23.0208333,69.9234815
            23.0208333,77.9982879 C23.0208333,86.0730944 36.3690476,87.3111714 36.3690476,87.3111714 L9.47916667,87.3111714 C9.47916667,87.3111714
            5.06725961e-16,88.9439496 0,95.7169558 C0,102.489962 9.47916667,104.243687 9.47916667,104.243687 L217.344853,104.243687 C217.344853,104.243687
            229.047619,102.913275 229.047619,95.7169558 C229.047619,88.5206368 217.344853,87.3111714 217.344853,87.3111714 L197.020332,87.3111714
            C197.020332,87.3111714 185.152433,86.6038872 184.940476,79.2682266 C184.728519,71.932566 197.020332,70.5600758 197.020332,70.5600758
            L220.606061,69.7436867 C220.606061,69.7436867 232.916667,71.5579653 232.916667,61.3681389 C232.916667,51.1783126 221.590909,52.5995149
            221.590909,52.5995149 L249.84375,52.6599882 C249.84375,52.6599882 260,52.0496912 260,44.1332573 C260,36.2168233 249.84375,35.2436867
            249.84375,35.2436867 L74.4791667,35.6669996 Z"
            id="Path-8"
            fill="#363E4E"
            opacity="0.02"
            filter="url(#filter-2)"
          />
          <path
            d="M156.585786,9 L176,28.4142136 L176,100 C176,101.932997 175.216498,103.682997 173.949747,104.949747 C172.682997,106.216498
            170.932997,107 169,107 L169,107 L110,107 C108.067003,107 106.317003,106.216498 105.050253,104.949747 C103.783502,103.682997
            103,101.932997 103,100 L103,100 L103,16 C103,14.0670034 103.783502,12.3170034 105.050253,11.0502525 C106.317003,9.78350169
            108.067003,9 110,9 L110,9 L156.585786,9 Z"
            id="Rectangle"
            strokeOpacity="0.3"
            stroke="#363E4E"
            strokeWidth="2"
            fill="#FFFFFF"
            transform="translate(139.500000, 58.000000) rotate(-15.000000) translate(-139.500000, -58.000000) "
          />
          <path
            d="M125.151542,48.6658927 C125.151542,50.5989353 124.256236,52.1658927 123.151816,52.1658927 C122.047121,52.1658927 121.151542,50.5989353
            121.151542,48.6658927 C121.151542,46.7328501 122.047121,45.1658927 123.151816,45.1658927 C124.256236,45.1658927 125.151542,46.7328501
            125.151542,48.6658927"
            id="Fill-38"
            fill="#363E4E"
            opacity="0.699999988"
            transform="translate(123.151542, 48.665893) rotate(-15.000000) translate(-123.151542, -48.665893) "
          />
          <path
            d="M151.231539,41.6777785 C151.231539,43.610821 150.336172,45.1777785 149.231676,45.1777785 C148.126906,45.1777785 147.231539,43.610821
            147.231539,41.6777785 C147.231539,39.7447359 148.126906,38.1777785 149.231676,38.1777785 C150.336172,38.1777785 151.231539,39.7447359
            151.231539,41.6777785"
            id="Fill-40"
            fill="#363E4E"
            opacity="0.699999988"
            transform="translate(149.231539, 41.677778) rotate(-15.000000) translate(-149.231539, -41.677778) "
          />
          <path
            d="M164.13009,80.5984991 C163.710485,80.5984991 163.302337,80.4433032 163.077021,80.1652793 C161.181639,77.8264378 158.455641,75.865109
            155.194038,74.4927069 C151.835769,73.0799301 147.988199,72.3330817 144.067354,72.3330817 C136.554807,72.3330817 129.644697,75.0310374
            125.582551,79.5502879 C125.22023,79.9535247 124.468379,80.0705604 123.903655,79.8119574 C123.338692,79.5533543 123.174478,79.0168977
            123.536799,78.6134906 C125.70237,76.2044616 128.695693,74.1937291 132.192876,72.7990102 C135.80224,71.3593168 139.908303,70.5984991
            144.067354,70.5984991 C148.422125,70.5984991 152.696459,71.4283117 156.428268,72.9984991 C160.049566,74.5220085 163.076305,76.699862
            165.180772,79.2966252 C165.516838,79.7112759 165.318492,80.24177 164.737538,80.4816337 C164.545876,80.56085 164.336551,80.5984991
            164.13009,80.5984991"
            id="Fill-42"
            fill="#363E4E"
            opacity="0.699999988"
            transform="translate(144.344340, 75.598499) rotate(-15.000000) translate(-144.344340, -75.598499) "
          />
          <path
            d="M145,4 L145,16 C145,20.418278 148.581722,24 153,24 L165,24 L165,24 L145,4 Z"
            id="Path-6"
            fill="#363E4E"
            opacity="0.3"
            transform="translate(155.000000, 14.000000) rotate(-15.000000) translate(-155.000000, -14.000000) "
          />
          <g id="Oval">
            <use fill="#FFFFFF" xlinkHref="#path-3" />
            <use
              strokeOpacity="0.3"
              stroke="#363E4E"
              strokeWidth="2"
              fillOpacity="0.06"
              fill="#363E4E"
              xlinkHref="#path-3"
            />
          </g>
          <path
            d="M190.744882,89.2474981 C191.060742,89.5648032 191.072891,89.8699049 190.781327,90.1628022 L185.970528,94.995606 L190.781327,99.828411
            C191.072891,100.170124 191.072891,100.48743 190.781327,100.780326 C190.635545,100.926775 190.465467,101 190.271091,101 C190.076716,101
            189.906637,100.926775 189.760856,100.780326 L185.022947,95.9475223 L180.212148,100.780326 C180.066367,100.926775 179.896288,101 179.701912,101
            C179.507537,101 179.361754,100.926775 179.264568,100.780326 C178.924409,100.48743 178.924409,100.170124 179.264568,99.828411 L184.002474,94.995606
            L179.264568,90.1628022 C178.924409,89.8699049 178.912261,89.5648032 179.228122,89.2474981 C179.543982,88.9301931 179.871991,88.9179886
            180.212148,89.2108858 L185.022947,94.0436909 L189.760856,89.2108858 C190.101012,88.9179886 190.429022,88.9301931 190.744882,89.2474981 Z"
            id="Shape-Copy-3"
            stroke="#363E4E"
            strokeWidth="0.8"
            fill="#191E28"
            fillRule="nonzero"
            opacity="0.699999988"
            transform="translate(185.000000, 95.000000) rotate(-15.000000) translate(-185.000000, -95.000000) "
          />
        </g>
      </g>
    </g>
  </Figure>
);
export default withTheme(SadResult);
